import { css } from '@emotion/core';

export const searchResultLinkCSS = css`
    display: flex;
    gap: 0.75rem;
    text-decoration: none;
`;

export const searchResultLinkProductCategoryCSS = ({ colors, fontSizes }) =>
    css`
        font-size: ${fontSizes.medium};
        color: ${colors.purpleLight};
    `;

export const searchResultLinkCustomerCategoryCSS = ({ colors, fontSizes }) =>
    css`
        font-size: ${fontSizes.medium};
        color: ${colors.blueLighter};
    `;
